import React from "react";

import GlobalConstants from "../GlobalConstants";
import AmazonLink from "../AvailableSizes/CarSeatsContainer/AmazonLink";
import AmazonLinkTo from "../AvailableSizes/ClothingContainer/AmazonLinkTo";

const SizeRow = ({ brand, size, gender, type }) => {
  var amazonLink = "";
  if( brand.amazon !== GlobalConstants.BRAND_UNAVAILABLE ) {
    if (type === "Clothing") {
      amazonLink = (
        <tr>
          <td className="text-center" colSpan="3">
            <AmazonLinkTo brand={brand}
              size={size}
              gender={gender}
              linkText={`Find ${brand.name} ${size.size} on Amazon`}/>
          </td>
        </tr>
      );
    } else {
      amazonLink = (
        <tr>
          <td className="text-center" colSpan="3">
            <AmazonLink brand={brand}
              size={size}
              linkText="Find it on Amazon"/>
          </td>
        </tr>
      );
    }
  }
  return(
    <tbody>
      <tr>
        <td>{size.size}</td>
        <td className="text-right">{size.minHeight} to {size.maxHeight} in.</td>
        {size.maxWeight !== 9999 &&
          <td className="text-right">{size.minWeight} to {size.maxWeight} lbs.</td>
        }
      </tr>

      { amazonLink }

    </tbody>
  );
};

SizeRow.propTypes = {
  brand: React.PropTypes.object.isRequired,
  size: React.PropTypes.object.isRequired,
  gender: React.PropTypes.string.isRequired,
  type: React.PropTypes.string.isRequired,
};

export default SizeRow;


/** WEBPACK FOOTER **
 ** ./src/components/Brands/SizeRow.js
 **/